import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * A custom element that displays a product SKU.
 * This component listens for variant update events and updates the SKU display accordingly.
 */
class ProductSku extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateSku);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateSku);
  }

  /**
   * Updates the SKU.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateSku = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    // Find the SKU element in the updated HTML
    // Try to find by block-id first (more specific), then fall back to section-id
    const blockId = this.dataset.blockId;
    const sectionId = this.dataset.sectionId;
    let newSkuElement = null;

    if (blockId) {
      newSkuElement = event.detail.data.html.querySelector(`product-sku[data-block-id="${blockId}"]`);
    }
    
    if (!newSkuElement && sectionId) {
      newSkuElement = event.detail.data.html.querySelector(`product-sku[data-section-id="${sectionId}"]`);
    }

    if (!newSkuElement) return;

    // Update the SKU content using morph
    morph(this, newSkuElement, { childrenOnly: true });
  };
}

if (!customElements.get('product-sku')) {
  customElements.define('product-sku', ProductSku);
}
